
export const services = [
  {
    icon: 'ri-loader-2-line',
    title: 'Ремонт стиральных машин',
    description: 'Профессиональный ремонт стиральных машин всех марок. Устраняем любые неисправности: не крутит барабан, не сливает воду, не греет, шумит при отжиме.',
    category: 'washing',
  },
  {
    icon: 'ri-drop-line',
    title: 'Ремонт посудомоечных машин',
    description: 'Качественный ремонт посудомоечных машин. Решаем проблемы с нагревом, сливом, протечками, не запускается программа мойки.',
    category: 'dishwasher',
  },
  {
    icon: 'ri-windy-line',
    title: 'Ремонт сушильных машин',
    description: 'Экспертный ремонт сушильных машин любых брендов. Не сушит, не греет, не крутит барабан, посторонние звуки — устраним быстро.',
    category: 'dryer',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Диагностика техники',
    description: 'Бесплатная диагностика на дому. Точное определение неисправности с использованием профессионального оборудования за 30 минут.',
    category: 'all',
  },
  {
    icon: 'ri-cpu-line',
    title: 'Замена запчастей',
    description: 'Оригинальные и совместимые запчасти для всех типов техники. Большой склад деталей, замена в день обращения с гарантией.',
    category: 'all',
  },
  {
    icon: 'ri-plug-line',
    title: 'Установка и подключение',
    description: 'Профессиональная установка стиральных, посудомоечных и сушильных машин. Подключение к водопроводу, канализации, электросети.',
    category: 'all',
  },
  {
    icon: 'ri-recycle-line',
    title: 'Профилактика и обслуживание',
    description: 'Регулярное техническое обслуживание для продления срока службы. Чистка, смазка, проверка всех систем.',
    category: 'all',
  },
  {
    icon: 'ri-alarm-warning-line',
    title: 'Срочный ремонт 24/7',
    description: 'Экстренный выезд мастера в любое время суток. Устраняем аварийные поломки в течение 2 часов по Алматы.',
    category: 'all',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Гарантийное обслуживание',
    description: 'Гарантия на все виды работ до 12 месяцев. Бесплатный повторный выезд при возникновении проблем.',
    category: 'all',
  },
];
